import Simple from "./Simple";
import NotFoundLoader from "./NotFoundLoader";
import Locale from "./LocaleLoader";

const loaderModule = { Simple, NotFoundLoader, Locale };
export default loaderModule;
